/* eslint-disable eqeqeq */
import reqwest from "reqwest"
import md5 from "../../common/util/md5"
import commonTools from "../../common/util/util"
import { isTest } from "../../config"
// import { Toast as AntdToast } from 'antd-mobile'

/** 这个文件中封装了一些常用的工具函数 **/
// console.log('youheWechat环境：', isTest ? '测试' : '线上')
const devwechat_id = '158';
// const devToken = "bd03d62bb378a6e9d5064dbccc9aa75d";
// const devUserId = "10711281";
const devToken = '5cf367b8fd2a447917990fc904ce297c'
const devUserId = '6623138'
const domainNames = [
  'qingtingxiaoshuo.com',
  '83xiaoshuo.cn',
  'bocaixiaoshuo.cn',
  'huixiangxiaoshuo.cn',
  'luotuoxiaoshuo.cn',
  'jielanxiaoshuo.cn',
  'youhezhuoyi.cn',
  'youhezhuoyi.com',
  'mymanbandeng.com',
  'yuedujidi.com',
]
const cpsDomainNames = [
  'zizaotai.cn',
  'manhama.cn',
  'udmusic.cn',
  'pingguxiaoshuo.com',
  'yhyuedu.com',
  'xsdoudou.cn',
  'yhyuewen.com',
  'freeyuedu.com',
  'youhexiaoshuo.com'
]
// 蘑菇书城
const moguDomainNames = [
  'doudouxiaoshuo.cn',
  'kxxsc.com',
  'youhegame.com',
]
// 判断是否是本地开发环境
const localDomainNames = ['localhost', '192.168.2.165', '192.168.1.120', '192.168.0.106', 'activity.free.idcfengye.com']
const local = localDomainNames.some(
  (item) => window.location.origin.indexOf(item) > -1
)
console.log("local", local)
// 判断是友和还是cps还是蘑菇书城
const isCpsMobile = cpsDomainNames.some((item) => window.location.origin.indexOf(item) > -1)
console.log("isCpsMobile", isCpsMobile)
const isYouhe = domainNames.some((item) => window.location.origin.indexOf(item) > -1)
console.log("isYouhe", isYouhe)
const isMoguMobile = local || moguDomainNames.some((item) => window.location.origin.indexOf(item) > -1)
console.log("isMoguMobile", isMoguMobile)

// const accreditHost = isCpsMobile ? "youhexiaoshuo.com" : "huangbianyu.cn"
// 预发布环境的wechatId
// const releaseWechats = ['283', '1554', '1556']
const releaseWechatsDomain = ['xiaoquzhushou', 'heisenyuedu', 'qingshuikanshu', 'huangguaaiyuedu', 'tianguaaidushu']
const isReleaseSite = releaseWechatsDomain.some(
  (item) => window.location.origin.indexOf(item) > -1
) // 判断是否是预发布环境

let cpsHost = '', proName = '', domainName = '', noSearch_domainName = ''
if (isYouhe) {
  cpsHost = 'cps.huangbianyu.cn'
  proName = 'youheWechat'
  domainName = domainNames.find((i) => window.location.origin.indexOf(i) > -1)
  noSearch_domainName = isTest ? 'https://test.yuedujidi.com' : 'https://nosearch.yuedujidi.com'
}
if (isCpsMobile) {
  cpsHost = 'cps.manhama.cn'
  proName = 'cpsMobile'
  domainName = cpsDomainNames.find((i) => window.location.origin.indexOf(i) > -1)
  noSearch_domainName = isTest ? 'https://test.udmusic.com' : 'https://tmp-nosearch.udmusic.cn'
}
if (isMoguMobile) {
  cpsHost = 'cps-open.feiku.com'
  proName = 'moguMobile'
  domainName = moguDomainNames.find((i) => window.location.origin.indexOf(i) > -1)
  noSearch_domainName = ''
}

const tools = {
  isTest,
  host: local || isReleaseSite ? 'https://release-open.' : "https://open.", // 接口地址
  isRelease: isReleaseSite,
  cpsHost, // cps后台接口域名
  proName,
  domainName: local ? "doudouxiaoshuo.cn" : domainName,
  noSearch_domainName,
  source: "",
  accreditHost: '',
  version: 1,
  app_secret: "4b6017ec4deb3c4f385b979d0e9cd7aa",
  user_token: "",
  wechat_id: "",
  user_id: "",
  appId: "wx6ab1ce8635991bc0",
  app_key: "3779629472",
  loadFirst(callback, App) {
    let cookieData = {};
    // if (commonTools.cookieObj()["cookieData"]) {
    //   cookieData = JSON.parse(commonTools.cookieObj()["cookieData"]);
    // }
    if (localStorage.getItem("userCookieInfo")) {
      cookieData = JSON.parse(localStorage.getItem("userCookieInfo"));
    }
    console.log(cookieData);
    this.wechat_id = local ? devwechat_id : cookieData.wechat_id || ''
    this.user_id = local ? devUserId : cookieData.user_id || ''
    this.user_token = local ? devToken : cookieData.user_token || ''
    this.domainName = tools.domainName
    commonTools.cnzzData.property = cookieData.property
    this.host = this.host + this.domainName
    this.accreditHost = isReleaseSite ? '' : localStorage.wx_auth_url || ''
    console.log(this.accreditHost)
    // 清除请求失败的接口
    sessionStorage.removeItem("urls")

    const par = commonTools.searchPar()
    console.log("par", par)
    let obj = localStorage.getItem('_promotion_data')
      ? JSON.parse(localStorage.getItem('_promotion_data'))
      : { promotions_id: '', channel_id: '' }
    if (par.promotions_id) {
      obj.promotions_id = par.promotions_id
      obj.channel_id = par.channel_id
    }
    localStorage.setItem("_promotion_data", JSON.stringify(obj))
    if (par.fontSize) {
      localStorage.setItem("_font_size", par.fontSize)
    }
    if (par.backColor) {
      localStorage.setItem("_default_back_color", par.backColor)
    }
    if (par.fontColor) {
      localStorage.setItem("_default_color", par.fontColor)
    }
    if (par.user_token) {
      this.user_token = par.user_token
      localStorage.setItem("userCookieInfo", JSON.stringify(par))
      if (par.wechat_id) {
        this.wechat_id = par.wechat_id;
      }
      if (par.source) {
        this.source = par.source;
        localStorage.setItem("source", par.source);
      }
      // 删除user_token，避免用户分享自己的账号出去
      const paramsJson = JSON.parse(JSON.stringify(par))
      delete paramsJson.user_token
      delete paramsJson.user_id
      delete paramsJson.wechat_id
      delete paramsJson.open_id
      delete paramsJson.property
      if (paramsJson.fromurl) {
        paramsJson.fromurl = encodeURIComponent(paramsJson.fromurl)
      }
      const paramsStr = commonTools.jsonToStr(paramsJson)
      const { origin, pathname } = window.location
      window.location.replace(`${origin}${pathname}${paramsStr ? '?' + paramsStr : ''}`)
      return
    }
    const tag = this.user_token ? false : true
    if (tag) {
      // 未登录
      if (isYouhe) {
        this.accreditHost = 'https://weixin.huangbianyu.cn'
        let tempData = {}
        reqwest(commonTools.getData({
          host: "https://weixin.huangbianyu.cn",
          url: "/zh/user/userCookie",
          noUserToken: true,
          data: {
            source: document.location.hostname,
          },
        }, this)).then((res) => {
          tempData = res.result.data || {};
          this.wechat_id = tempData.wechat_id;
          this.user_id = tempData.user_id;
          this.user_token = tempData.user_token || "";
          this.open_id = tempData.open_id || "";
          commonTools.cnzzData.property = tempData.property;
          localStorage.setItem("userCookieInfo", JSON.stringify(tempData));
        }).always(() => {
          // console.log(this.user_token)
          if (!this.user_token) {
            commonTools.getAccredit('https://weixin.huangbianyu.cn');
          } else {
            this.loginEnd(par, callback, App);
          }
        })
      } else {
        this.ajax({
          url: "/zh/wechat/info",
          noUserToken: true,
          data: {
            source: local ? 'huangguaaiyuedu.doudouxiaoshuo.cn' : document.location.hostname,
          },
          callback: (res) => {
            const { status, data } = res.result
            try {
              if (status.code == 0) {
                if (data.tourist_status == '1') {
                  // 安全模式
                  if (par.open_id) {
                    // 安全模式下open_id登录方式
                    console.log('open_id登录方式')
                    this.ajax({
                      url: "/zh/user/openidLogin",
                      method: 'get',
                      noUserToken: true,
                      data: {
                        wechat_id: data.wechat_id,
                        open_id: par.open_id
                      },
                      callback: (res) => {
                        if (res.result.status.code == 0) {
                          const tempData = res.result.data || {}
                          this.wechat_id = tempData.wechat_id
                          this.user_id = tempData.user_id
                          this.user_token = tempData.user_token || ""
                          commonTools.cnzzData.property = tempData.property
                          localStorage.setItem("userCookieInfo", JSON.stringify(tempData))
                          const paramsJson = JSON.parse(JSON.stringify(par))
                          delete paramsJson.open_id
                          if (paramsJson.fromurl) {
                            paramsJson.fromurl = encodeURIComponent(paramsJson.fromurl)
                          }
                          const paramsStr = commonTools.jsonToStr(paramsJson)
                          const { origin, pathname } = window.location
                          // console.log(paramsJson)
                          // console.log(`${origin}${pathname}${paramsStr ? '?' + paramsStr : ''}`)
                          window.location.replace(`${origin}${pathname}${paramsStr ? '?' + paramsStr : ''}`)
                          return
                        } else {
                          console.log(res.result.status.msg)
                        }
                      }
                    })
                  } else if (!par.open_id && data.tourist_wechat && data.tourist_wechat_source) {
                    // 安全模式下跳转至兜底站点，通过携带from_wechat参数表明
                    console.log('跳转兜底站点')
                    const { pathname, search } = window.location
                    // console.log(`${data.tourist_wechat_source}${pathname}${search}`)
                    window.location.replace(`${data.tourist_wechat_source}${pathname}${search ? `${search}&from_wechat=${data.wechat_id}` : `?from_wechat=${data.wechat_id}`}`)
                  } else {
                    // 安全模式下游客登录
                    console.log('游客登录')
                    this.ajax({
                      url: "/zh/user/guestLogin",
                      method: 'post',
                      noUserToken: true,
                      data: {
                        wechat_id: data.wechat_id,
                      },
                      callback: (res) => {
                        const tempData = res.result.data || {}
                        this.wechat_id = tempData.wechat_id
                        this.user_id = tempData.user_id
                        this.user_token = tempData.user_token || ""
                        commonTools.cnzzData.property = tempData.property
                        localStorage.setItem("userCookieInfo", JSON.stringify(tempData))
                        // console.log(this.user_token)
                        this.loginEnd(par, callback, App)
                      }
                    })
                  }
                } else if (data.login_protect == '1') {
                  // 登录域名保护模式下，游客登录
                  this.ajax({
                    url: "/zh/user/guestLogin",
                    method: 'post',
                    noUserToken: true,
                    data: {
                      wechat_id: data.wechat_id,
                    },
                    callback: (res) => {
                      const tempData = res.result.data || {}
                      this.wechat_id = tempData.wechat_id
                      this.user_id = tempData.user_id
                      this.user_token = tempData.user_token || ""
                      commonTools.cnzzData.property = tempData.property
                      localStorage.setItem("userCookieInfo", JSON.stringify(tempData))
                      // console.log(this.user_token)
                      this.loginEnd(par, callback, App)
                    }
                  })
                } else {
                  // 微信登录模式
                  this.accreditHost = local || isReleaseSite ? '' : data.wx_auth_url
                  localStorage.setItem("wx_auth_url", data.wx_auth_url)
                  commonTools.getAccredit(data.wx_auth_url)
                }
              }
            } catch (e) {
              // console.log(e)
            }
          }
        })
      }
    } else {
      this.loginEnd(par, callback, App);
    }
  },
  loginEnd(par, callback, App) {
    // 已登录
    const loginInfo = JSON.parse(localStorage.getItem("userCookieInfo"));
    if (loginInfo && par.from && par.fromurl) {
      // 从活动页面进来的
      console.log('活动页面进入')
      // console.log(`${par.fromurl}&user_token=${loginInfo.user_token}&user_id=${loginInfo.user_id}&wechat_id=${loginInfo.wechat_id}&property=${loginInfo.property}`)
      window.location.replace(`${par.fromurl}&user_token=${loginInfo.user_token}&user_id=${loginInfo.user_id}&wechat_id=${loginInfo.wechat_id}&property=${loginInfo.property}`)
      return
    }
    if (par.open_id) {
      // 在缓存有登录信息的情况下，要删掉链接上的open_id
      const paramsJson = JSON.parse(JSON.stringify(par))
      delete paramsJson.open_id
      const paramsStr = commonTools.jsonToStr(paramsJson)
      const { origin, pathname } = window.location
      // console.log(paramsJson)
      // console.log(`${origin}${pathname}${paramsStr ? '?' + paramsStr : ''}`)
      window.location.replace(`${origin}${pathname}${paramsStr ? '?' + paramsStr : ''}`)
      return
    }

    // const isRelease = releaseWechats.includes(this.wechat_id) // 判断是否是预发布环境
    console.log('isRelease', this.isRelease)
    // if (isRelease || local) {
    //   this.host = 'https://release-open.' + this.domainName
    //   this.isRelease = isRelease
    // }
    if (
      sessionStorage.getItem("logintime") &&
      new Date().getTime() - sessionStorage.getItem("logintime") >=
      60 * 60 * 1000 * 2
    ) {
      sessionStorage.removeItem("logintime");
      commonTools.getAccredit(this.accreditHost || this.domainName);
    } else {
      sessionStorage.setItem("logintime", new Date().getTime());

      // 判断用户是否符合打开网站的要求
      this.ajax({
        url: "/zh/user/check_open", // URL
        isWechatId: true,
        isUser: true,
        callback: (res) => {
          const { status, data } = res.result
          if (status.code == 0) {
            localStorage.checkOpenIsOpen = data.is_open
            const { origin, pathname } = window.location
            if (data.check_ip && data.check_ip == 1) {
              // IP黑名单进入
              window.location.href = 'https://mp.weixin.qq.com/s/4qr1IEBvHOfRGtzzssx_NA'
              return false
            } else if (data.is_subscribe == 0) {
              // 未关注进入
              if (pathname != '/notFollow') {
                window.location.href = `${origin}/notFollow`
              }
            } else if (data.is_open == 0) {
              // 被防转发进入
              localStorage.checkOpenBookId = data.book_id
              localStorage.checkOpenContentId = data.content_id
              const readPageArr = ['/readpage', '/bookContent', '/content', '/bookReadPage', '/bookText']
              const hasPath = readPageArr.some((item) => pathname.indexOf(item) > -1)
              if (data.book_id && hasPath) {
                // 链接是阅读页则跳转到指定书籍阅读页，否则正常进入
                window.history.replaceState({}, '', `${origin}/bookContent/${data.book_id}/${data.content_id}`)
              }
            }
          }
        }
      })
      // 获取公众号、客服配置
      this.ajax({
        url: "/zh/wechat/info", // URL
        isWechatId: true,
        isUser: true,
        data: {
          from_wechat: par.from_wechat || ''
        },
        callback: (res) => {
          const { status, data } = res.result
          try {
            if (status.code == 0) {
              commonTools.cnzzData = data
              this.accreditHost = isReleaseSite ? '' : data.wx_auth_url
              localStorage.setItem("wechatInfo", JSON.stringify(data))
              localStorage.setItem("wx_auth_url", data.wx_auth_url)
              if (data.wechatconf) {
                localStorage.setItem("kefuInfo", JSON.stringify(data.wechatconf))
              }
            }
            commonTools.addCnzz()
          } catch (e) {
            console.log(e)
          }
        },
        alwaysFun: () => {
          if (!!callback) {
            localStorage.setItem('firstUrl', window.location.href)
            callback(App)
          }
        }
      })

      if (!!par.promotions_id) {
        this.ajax({
          url: "/zh/additional/pv",
          method: "post",
          isUser: true,
          data: {
            promotions_id: par.promotions_id,
          },
        })
      }
      // 模板消息推广链接
      if (par.template_news_id) {
        this.ajax({
          url: "/zh/additional/pvv1",
          method: "post",
          isUser: true,
          data: {
            template_news_id: par.template_news_id,
          },
        })
      }
      // 客服消息推广链接
      if (par.customer_service_id) {
        this.ajax({
          url: "/zh/additional/pvv1",
          method: "post",
          isUser: true,
          data: {
            customer_service_id: par.customer_service_id,
          },
        })
      }
      if (!!par.channel_id && !!par.promotions_id && !this.postClick) {
        this.postClick = true;
        let tempData = {
          promotion_id: par.promotions_id,
          random: commonTools.randomNum(6),
          timestamp: new Date().getTime(),
          user_id: this.user_id,
          app_secret: "r5e2t85tyu142u665698fzu",
          app_key: "5288971",
        };
        let str = `promotion_id${tempData.promotion_id}random${tempData.random}timestamp${tempData.timestamp}user_id${tempData.user_id}${tempData.app_secret}`;
        console.log(str);
        tempData.access_token = md5.hexMD5(str).toUpperCase();
        console.log("tempData: ", tempData);
        console.log("this.cpsHost: ", this.cpsHost);
        reqwest({
          url: "//" + this.cpsHost + "/promotion/link_click_count",
          method: "get",
          crossOrigin: true, // 开启CORS跨域
          withCredentials: true, // 请求头中是否带cookie，有利于后端开发保持他们需要的session
          data: tempData, // 参数，弄成json字符串
          type: "json", // 参数类型JSON
        });

        reqwest(commonTools.getData({
          url: "/zh/user/updateChannel",
          isUser: true,
          isWechatId: true,
          method: "post",
          data: {
            channel_id: par.channel_id,
            promotions_id: par.promotions_id,
          },
        }, this));
      }
      // 公众号用户绑定企业微信
      if (par.qy_uid && par.qy_tuid) {
        this.ajax({
          url: "/yd/qyuserrelate/add",
          method: "post",
          isUser: true,
          data: {
            qy_uid: par.qy_uid,
            qy_tuid: par.qy_tuid,
          },
        })
      }
      // 公众号用户绑定圈量科技
      if (par.qlid) {
        this.ajax({
          url: "/yd/qluserrelate/add",
          method: "post",
          isUser: true,
          data: {
            qlid: par.qlid,
          },
        })
      }
      // 公众号用户绑定第三方平台
      if (par.out_uid) {
        this.ajax({
          url: "/yd/outuserrelate/add",
          method: "get",
          isUser: true,
          data: {
            out_uid: par.out_uid,
          },
        })
      }
      // 通过粉丝导流过来的公众号用户
      if (par.diversion_user_id) {
        this.ajax({
          url: "/zh/wechat/copyData",
          method: "get",
          isUser: true,
          data: {
            old_user_id: par.diversion_user_id,
          },
        })
      }
    }
  },
  ajax(data) {
    // if (data && data.data) {
    //   data.data.wechat_id = this.wechat_id;
    //   data.data.user_token = this.user_token;
    // }
    // if (!this.user_token) {
    //   commonTools.getAccredit(this.accreditHost || this.domainName);
    //   return false;
    // } else {
      if (
        !!sessionStorage.getItem("logintime") &&
        new Date().getTime() - sessionStorage.getItem("logintime") >=
        60 * 60 * 1000 * 2
      ) {
        sessionStorage.removeItem("logintime");
        commonTools.getAccredit(this.accreditHost || this.domainName);
        return false;
      }
    // }
    let curUrl = data.url + commonTools.jsonToStr(data.data);
    let localUrl = JSON.parse(sessionStorage.getItem("urls") || "[]");

    localUrl.push(curUrl);
    sessionStorage.setItem("urls", JSON.stringify(localUrl));
    let dataPar = commonTools.getData(data, this);
    if (!data.noUserToken && !dataPar.data.user_token) {
      // console.log(dataPar)
      window.location.reload()
      return false
    }
    reqwest(dataPar)
      .then((res) => {
        if (
          res.result.status.code == 30016 ||
          res.result.status.code == 30017 ||
          res.result.status.code == 30024
        ) {
          localStorage.removeItem('userCookieInfo')
          if (window.location.origin == this.noSearch_domainName) {
            // 如果在禁搜域名下则跳转回来源域名去授权登录
            const { pathname, origin } = window.location;
            console.log(
              `${this.source}${pathname}?sourcePage=${origin}${pathname}`
            );
            window.location.href = `${this.source}${pathname}?sourcePage=${origin}${pathname}`;
          } else if (this.user_token != "buqushouquan") {
            // console.log('这儿345')
            commonTools.getAccredit(this.accreditHost || this.domainName);
          }
        }
        if (typeof data.callback == "function") {
          data.callback(res);
        }
      })
      .catch((e) => {
        e.requestPar = dataPar;
        commonTools.checkLog(e, this);
      })
      .always(() => {
        let localUrl = JSON.parse(sessionStorage.getItem("urls") || "[]");
        localUrl.splice(localUrl.indexOf(curUrl), 1);
        sessionStorage.setItem("urls", JSON.stringify(localUrl));
        if (typeof data.alwaysFun == "function") {
          try {
            data.alwaysFun();
          } catch (e) {
            console.log(e)
          }
        }
      });
  },
};

export default tools;
